import { ReactNode, useMemo } from 'react';
import { useGlobalComponent } from '@rhino-project/core/hooks';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';

export const CellLinkBase = ({
  children,
  empty = '-',
  ...props
}: TableInheritedProps & { children?: ReactNode; empty?: string }) => {
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const linkText = useMemo(
    () => children || getValue!() || empty,
    [children, empty, getValue]
  );

  if (!getValue!()) return <div {...inheritedProps}>{empty}</div>;

  // Stop propogation of the click event so that the row click handling does not fire
  return (
    <a
      href={getValue!()}
      onClick={(e) => e.stopPropagation()}
      {...inheritedProps}
    >
      {linkText}
    </a>
  );
};

export const CellLink = (props: TableInheritedProps) =>
  useGlobalComponent('CellLink', CellLinkBase, props);
